import { Input } from '@components';
import { styled } from '@mui/material';

export const StyledResetEmailInput = styled(Input)(({ theme }) => ({
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: { flex: 1 },
  [theme.breakpoints.down('lg')]: {
    flex: '1 0 100%',
  },
}));
